<template>
<el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <el-drawer title="风控" @close="closeDialog"  direction="ltr" size="50%"  :visible="fengkongFlag" :close-on-click-modal="false" :wrapper-closable="false" >
      <div style="padding:12px" class="inpBox">
        <el-form-item label="运单编号:" prop="payee"  >
          <span>{{goodform.wayNo}}</span>
        </el-form-item>
        <el-form-item label="订单号:"  >
          <span>{{goodform.orderNo?goodform.orderNo:'-'}}</span>
        </el-form-item>
        <el-form-item label="创建人:"   >
          <span>{{goodform.createUser}}</span>
        </el-form-item>
        <br>
        <el-form-item label="结算客户:" prop="payee"  >
          <el-select  v-model="goodform.payee" v-if="jskhFlag&&!goodform.isSG" filterable placeholder="请选择" @change="jiesuanChange">
            <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
          </el-select>
          <span v-else>{{goodform.payee}}</span>
        </el-form-item>
        <el-form-item label="项目名称:" prop="projectType"   >
          <el-select  v-model="goodform.projectType" filterable placeholder="请选择">
            <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型:" prop="wayBusinessType"   v-if="!goodform.isSG">
          <el-select  v-model="goodform.wayBusinessType"    placeholder="请选择">
            <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型:"  v-if="goodform.isSG"  >
          <span >{{goodform.wayBusinessTypeName}}</span>
        </el-form-item>
        <el-form-item label="销售合同:"  >
          <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.salesContract"  ></el-input>
        </el-form-item>
        <el-button type="text"  @click="xuanzeHT" style="margin-top: 8px;">选择</el-button>
        <el-form-item label="外部单号:"  >
          <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
        </el-form-item>
        <!-- <el-form-item label="业务部门:" prop="insuranceInfo"   >
          <div style="width:150px">{{goodform.businessUnit}}</div>
        </el-form-item> -->
        <el-form-item label="业务人员:" prop="insuranceInfo"  v-if="isZhuanbao" >
          <div style="width:150px">{{goodform.businessUser}}</div>
        </el-form-item>
        <el-form-item label="业务人员:" prop="businessUserId" v-if="!isZhuanbao">
          <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
          <el-select  v-else v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
            <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <hr>
        <!-- 地址组件 -->
        <addDizhi :goodform="goodform" v-if="fengkongFlag&&goodform.receivingAddressId" ></addDizhi>
        <hr>
        <!-- 添加货物外库 -->
       <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货物信息</span>
            </h4>
        </div>
        <el-form-item  label="货物类型:" >
            <div style="width:80px">{{goodform.productTypeName}}</div>
        </el-form-item>
        <el-form-item  label="计量单位:" >
            <div style="width:80px">{{goodform.measuringUnit}}</div>
        </el-form-item>
        <el-form-item  label="重量(吨):">
            <div style="width:80px">{{goodform.dispatchWeightT?goodform.dispatchWeightT:'-'}}</div>
        </el-form-item>
        <el-form-item  label="数量(件):">
            <div style="width:80px">{{goodform.dispatchNumber?goodform.dispatchNumber:'-'}}</div>
        </el-form-item>
        <el-form-item  label="体积(方):">
            <div style="width:80px">{{goodform.dispatchVolumn?goodform.dispatchVolumn:'-'}}</div>
        </el-form-item>
        <el-form-item  label="货物备注:">
            <div style="width:80px">{{goodform.productRemark?goodform.productRemark:'-'}}</div>
        </el-form-item>
        <div style="text-align: right; margin-top: -20px;padding-right: 20px;" v-if="goodform.goodsList.length>0">
          <i class="el-icon-arrow-down icon" v-if="isZhankai" @click="isZhankai=!isZhankai"></i>
          <i class="el-icon-arrow-up icon" v-if="!isZhankai"  @click="isZhankai=!isZhankai"></i>
        </div>
        <div style="padding:0 16px 16px 16px;" v-if="isZhankai&&goodform.goodsList.length>0">
        <el-table height="300px" size="mini" ref="tabref" :data="goodform.goodsList" style="width:100%" border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
           <el-table-column label="操作"  width="200" v-if="!(goodform.isSG&&(goodform.productTypeName=='中厚板'||goodform.productTypeName=='剪切板'))">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="delFn(scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true"  prop="customerName"
            label="货权客户" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
            min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        </el-table>
      </div>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
           <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>结算信息</span>
        </h4>
        <shouruQS :goodform="goodform" v-if="!isZhuanbao"></shouruQS>
        <shouruWayZB :goodform="goodform" :isqianshou="true"  v-if="isZhuanbao"></shouruWayZB>
      </div>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>运费信息</span>
        </h4>
        <cheliangxinxiSG :goodform="goodform"></cheliangxinxiSG>
        <zhichu2QS :goodform="goodform" ></zhichu2QS>
      </div>
      </div>
      <el-drawer title="" size="98%" @close="closeDialog"   class="rightDrawer"  :wrapper-closable="false"
        append-to-body :modal="false"  :visible="fengkongFlag">
        <div  style="padding:10px">
        <div class="addressBox" >
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>装车</span>
          </h4>
          <el-form-item label="装车量:"  prop="truckload" class="danweiBox width1 jiage" >
            <el-input  placeholder="" v-number-input.float="3"  @blur="zcFn"  maxlength="8"  v-model="goodform.truckload" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
            <el-input  placeholder="" v-number-input.float="0"  @blur="zcFn" maxlength="8"  v-model="goodform.truckload" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
            <span class="danwei">{{goodform.measuringUnit}}</span>
          </el-form-item>
          <el-form-item label="装车时间:" prop="actualLoadingTime">
                <el-date-picker  v-model="goodform.actualLoadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                  type="datetime"></el-date-picker>
          </el-form-item>
          <uploadImgs :imgList.sync='ZCimgList' :max=10 @remove="remove"></uploadImgs>
          <div style="margin-bottom:20px; font-size: 12px;" v-if="ZCimgList.length>0">
            <span style="margin: 10px 50px 10px 10px;">上传人：{{ZCimgList[0].createUser}}</span>
            <span>上传时间：{{ZCimgList[0].createTime|dateFormat}} </span></div>
        </div>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>卸车</span>
          </h4>
          <el-form-item label="卸车量:"  prop="unloadings" class="danweiBox width1 jiage">
            <el-input  placeholder="" v-number-input.float="3" @blur="xcFn"  maxlength="8"  v-model="goodform.unloadings" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
            <el-input  placeholder="" v-number-input.float="0" @blur="xcFn"  maxlength="8"  v-model="goodform.unloadings" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
            <span class="danwei">{{goodform.measuringUnit}}</span>
          </el-form-item>
          <el-form-item label="卸车时间:" prop="actualUnloadingTime">
                <el-date-picker  v-model="goodform.actualUnloadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                  type="datetime" @change="actualUnloadingTimeFn"></el-date-picker>
          </el-form-item>
          <div style="margin:0 0 5px 15px; font-size: 12px;">*回单</div>
          <uploadImgs :imgList.sync='XCimgList' :max=10 @remove="remove"></uploadImgs>
          <div style="margin-bottom:5px; font-size:12px;"  v-if="XCimgList.length>0">
            <span style="margin: 10px 50px 10px 10px;">上传人：{{XCimgList[0].createUser}}</span>
            <span>上传时间：{{XCimgList[0].createTime|dateFormat}} </span></div>
        </div>
        <div class="addressBox" style="padding-top: 15px;">
          <!-- <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>签收</span>
          </h4> -->
          <el-form-item label="异常原因:" style="margin-left: -10px;">
            <el-input placeholder="请输入" type="textarea" maxlength="200" v-model="goodform.signRiskControlRemark" style="width: 250px;" rows="3"></el-input>
          </el-form-item>
        </div>
        <div class="addressBox" style="margin-top:2px">
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>查看轨迹</span>
          </h4>
            <div style="height: 400px; position: relative;box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);" v-if="fengkongFlag">
            <!-- <div class="map-toolbar">
              <el-button type="primary" size="mini" @click="openFullscreenMap" icon="el-icon-full-screen">全屏查看轨迹</el-button>
            </div> -->
            <maphistory :mapData="goodform" :heightFlag = 'true' v-if="goodform && goodform.id"></maphistory>
          </div>
        </div>
        <div class="bottomBtn">
          <el-button @click="closeDialog"  >取 消</el-button>
          <el-button type="primary" @click="savePDFn(1)">确 认</el-button>
          <el-button type="primary" @click="savePDFn(2)">通 过</el-button>
          <el-button type="primary" @click="savePDFn(3)">异 常</el-button>
        </div>
        </div>
      </el-drawer>
  </el-drawer>
  <!-- 关联合同 -->
  <guanlianhetong :goodform="goodform" v-if="GLHTflag" :GLHTflag.sync='GLHTflag'></guanlianhetong>
</el-form>
</template>

<script>
import cheliangxinxiSG from '@/views/newTMS/publicFiles/wayAndOrder/cheliangxinxiSG.vue'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhi.vue'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import guanlianhetong from '@/views/newTMS/publicFiles/wayAndOrder/guanlianhetong.vue'
import zhichu2QS from '@/views/newTMS/publicFiles/wayAndOrder/zhichu2QS.vue'
import shouruQS from '@/views/newTMS/publicFiles/wayAndOrder/shouruQS.vue'
import shouruWayZB from '@/views/newTMS/publicFiles/wayAndOrder/shouruWayZB.vue'
import maphistory from '@/views/newTMS/publicFiles/wayManage/fk-map.vue'
// import maphistoryT from '@/views/newTMS/publicFiles/wayManage/maphistory.vue'
import { getDictionaryDetailList, findCustomerInfoList, getWaynfo, findWayAttachments, signRisk } from '@/api/newTMS'
import { selectTMSTenantListByCustom, getDepartmentUsers } from '@/api/newCrm'
import { compressImages } from '@/utils/compressImages'
import { formatterRowEmpty, dateFormatUtil } from '@/utils/util'
export default {
  name: 'addEditWay',
  components: {
    cheliangxinxiSG, zhichu2QS, addDizhi, guanlianhetong, shouruQS, uploadImgs, shouruWayZB, maphistory
  },
  props: {
    fengkongFlag: {
      type: Boolean,
      default: false
    },
    glhwFlag: {
      type: Boolean,
      default: false
    },
    wayBusinessId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      goodform: {
        goodsList: [],
        measuringUnit: '吨',
        wayState: 1,

        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0'
      },
      dateFormatUtil: dateFormatUtil,
      ZCimgList: [],
      XCimgList: [],
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        wayBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        allWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        truckload: [
          { required: true, message: '请输入装车量', trigger: 'blur' }
        ],
        unloadings: [
          { required: true, message: '请输入卸车量', trigger: 'blur' }
        ],
        actualLoadingTime: [
          { required: true, message: '请选择装车时间', trigger: 'blur' }
        ],
        actualUnloadingTime: [
          { required: true, message: '请选择卸车时间', trigger: 'blur' }
        ]
        // deliverPerson: [
        //   { pattern: this.rule.xingming, message: '请输入正确的发货人' }
        // ],
        // receivingPerson: [
        //   { pattern: this.rule.xingming, message: '请输入正确的收货人' }
        // ]
      },
      kehuList: [], // 结算客户
      YWLXlist: [], // 业务类型
      fileArr: [],
      GLHTflag: false, // 关联合同
      tWayBusiness: {}, // 运单业务字段
      deleteAttachmentsIds: [],
      yonghuList: [],
      ywyhFlag: false, // 客户身上是否有业务用户
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      isZhankai: false,
      jskhFlag: true, // 结算客户是否可修改
      isZhuanbao: null,
      XMlist: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })

    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    if (this.wayBusinessId) {
      getWaynfo({ wayBusinessId: this.wayBusinessId }).then(res => {
        this.goodform = res.tWay
        if (res.tOrderBusiness) {
          this.isZhuanbao = res.tOrderBusiness.orderSource == 1
        } else {
          this.isZhuanbao = false
        }
        this.$set(this.goodform, 'disburseSurchargeFlag', 1)

        findWayAttachments({ wayId: this.goodform.id }).then(res => {
          res.wayLoadAttachmentsList.forEach(item => {
            this.ZCimgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, createUser: item.createUser, createTime: item.createTime })
          })
          res.wayUnloadAttachmentsList.forEach(item => {
            this.XCimgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, createUser: item.createUser, createTime: item.createTime })
          })
        })

        if (this.goodform.pickupTimeStart) {
          this.$set(this.goodform, 'pickupTime', [this.goodform.pickupTimeStart, this.goodform.pickupTimeEnd])
        }

        this.$set(this.goodform, 'wayBusinessType', res.tWay.wayBusinessType.toString())
        this.$set(this.goodform, 'payee', res.tWayBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tWayBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tWayBusiness.payeeCode)
        this.goodform.deleteWayGoodsRelIds = []
        if (res.tWay.productType) {
          this.$set(this.goodform, 'productType', res.tWay.productType.toString())
        }
        if (res.tWay.licensePlateColor) {
          this.$set(this.goodform, 'licensePlateColor', Number(res.tWay.licensePlateColor))
        }
        this.tWayBusiness = res.tWayBusiness

        // 附件回显
        res.wayAttachmentsList.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.fileArr.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, name: filename })
        })
        // 收入相关
        this.$set(this.goodform, 'incomePattern', res.tWayBusiness.incomePattern.toString())
        this.$set(this.goodform, 'incomePatternName', res.tWayBusiness.incomePatternName)
        this.$set(this.goodform, 'revenueValuation', res.tWayBusiness.revenueValuation.toString())
        this.$set(this.goodform, 'revenueValuationName', res.tWayBusiness.revenueValuationName)
        this.$set(this.goodform, 'makeTicketYn', res.tWayBusiness.makeTicketYn)
        this.$set(this.goodform, 'ticketSystemYn', res.tWayBusiness.ticketSystemYn)
        if (res.tWayBusiness.incomeUnitPrice) {
          this.$set(this.goodform, 'incomeUnitPrice', res.tWayBusiness.incomeUnitPrice / 100)
        }
        if (res.tWayBusiness.incomeAmount) {
          this.$set(this.goodform, 'incomeAmount', res.tWayBusiness.incomeAmount / 100)
        }
        if (res.tWayBusiness.grossRevenue) {
          this.$set(this.goodform, 'grossRevenue', res.tWayBusiness.grossRevenue / 100)
        }
        if (res.tWayBusiness.revenueSurcharge) {
          this.$set(this.goodform, 'revenueSurcharge', res.tWayBusiness.revenueSurcharge / 100)
        }
        if (res.tWayBusiness.disburseSurcharge) {
          this.$set(this.goodform, 'disburseSurcharge', res.tWayBusiness.disburseSurcharge / 100)
        }
        this.$set(this.goodform, 'payee', res.tWayBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tWayBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tWayBusiness.payeeCode)

        // 运力支出相关
        this.$set(this.goodform, 'generalCarrier', res.tWayBusiness.generalCarrier)
        this.$set(this.goodform, 'generalTaxId', res.tWayBusiness.generalTaxId)
        this.$set(this.goodform, 'collectionType', res.tWayBusiness.collectionType)
        this.$set(this.goodform, 'payer', res.tWayBusiness.payer)
        this.$set(this.goodform, 'payerTaxId', res.tWayBusiness.payerTaxId)
        this.$set(this.goodform, 'payerCode', res.tWayBusiness.payerCode)
        if (res.tWayBusiness.expenditurePattern || res.tWayBusiness.expenditurePattern === 0) {
          this.$set(this.goodform, 'expenditurePattern', res.tWayBusiness.expenditurePattern.toString())
          this.$set(this.goodform, 'expenditurePatternName', res.tWayBusiness.expenditurePatternName)
        }
        if (res.tWayBusiness.freightPricingType || res.tWayBusiness.freightPricingType === 0) {
          this.$set(this.goodform, 'freightPricingType', res.tWayBusiness.freightPricingType.toString())
          this.$set(this.goodform, 'freightPricingTypeName', res.tWayBusiness.freightPricingTypeName)
        }
        if (res.tWayBusiness.freightUnitPrice) {
          this.$set(this.goodform, 'freightUnitPrice', res.tWayBusiness.freightUnitPrice / 100)
        }
        if (res.tWayBusiness.freightAmount) {
          this.$set(this.goodform, 'allFreightAmount', res.tWayBusiness.freightAmount / 100)
        }
        this.$set(this.goodform, 'serviceRate', res.tWayBusiness.serviceRate)
        this.$set(this.goodform, 'serviceCharge', res.tWayBusiness.serviceCharge)
        this.$set(this.goodform, 'freightTaxRate', res.tWayBusiness.freightTaxRate)
        this.$set(this.goodform, 'freightRemark', res.tWayBusiness.freightRemark)
        this.$set(this.goodform, 'incomeRemark', res.tWayBusiness.incomeRemark)
        // 网货信息
        // this.$set(this.goodform, 'onlineFreightFlag', 0)
        // 货物信息
        this.$set(this.goodform, 'goodsList', res.goodslist)
        this.$set(this.goodform, 'allWeight', res.tWay.dispatchWeight)
        if (res.goodslist.length > 0) {
          this.isZhankai = true
        }
        // 应收状态
        this.$set(this.goodform, 'ysSettlementStates', res.tWayBusiness.ysSettlementStates)
        // 判断是不是首钢
        if (this.goodform.waySource == 2) {
          this.goodform.isSG = true
        } else {
          this.goodform.isSG = false
        }
        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json.length > 0) {
              if (json[0].businessUserCode) {
                this.ywyhFlag = true
              } else {
                this.ywyhFlag = false
              }
              this.jskhFlag = true
            } else {
              this.jskhFlag = false
            }
          })
        })
      })
    }
  },
  methods: {
    zcFn () {
      // if (this.goodform.truckload > 40) {
      //   this.$alert('装车量超过标载40吨！', '系统提示')
      // }
    },
    xcFn () {
      // if (this.goodform.unloadings > 40) {
      //   this.$alert('卸车量超过标载40吨！', '系统提示')
      // }
    },
    jsFn () {
      // if (this.goodform.truckload != this.goodform.unloadings) {
      //   let timer = setTimeout(() => {
      //     this.$alert('装车量和卸车量不一致！', '系统提示')
      //     clearTimeout(timer)
      //     timer = null
      //   })
      // }
    },
    // 卸车时间
    actualUnloadingTimeFn (e) {
      var timestamp1 = new Date(e).getTime()
      let timestamp2 = new Date(this.goodform.actualLoadingTime).getTime()
      if (timestamp1 < timestamp2) {
        this.$alert('卸车时间需要大于装车时间', '系统提示')
        this.$set(this.goodform, 'actualUnloadingTime', null)
      }
    },
    // 删除货物
    delFn (index) {
      if (this.goodform.goodsList.length == 1) {
        this.$alert('最后一条货物不允许删除', '系统提示')
        return
      }
      if (this.goodform.wmsOutstockNo) {
        this.$confirm('删除后对应仓库出库单货物也会删除，是否继续？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          if (this.goodform.goodsList[index].wayGoodsRelId) {
            this.goodform.deleteWayGoodsRelIds.push(this.goodform.goodsList[index].wayGoodsRelId)
          }
          this.goodform.goodsList.splice(index, 1)
          this.getAllWeight()
        }).catch(() => {

        })
      } else {
        if (this.goodform.goodsList[index].wayGoodsRelId) {
          this.goodform.deleteWayGoodsRelIds.push(this.goodform.goodsList[index].wayGoodsRelId)
        }
        this.goodform.goodsList.splice(index, 1)
        this.getAllWeight()
      }
    },
    // 计算货物重量
    getAllWeight () {
      this.allWeight = 0
      let allNumber = 0
      let allvolumn = 0
      this.goodform.goodsList.forEach(item => {
        if (item.weight) {
          this.allWeight = (this.allWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          allNumber = (allNumber * 1000 + item.number * 1000) / 1000
        }
        if (item.volumn) {
          allvolumn = (allvolumn * 1000 + item.volumn * 1000) / 1000
        }
      })
      this.$set(this.goodform, 'dispatchWeightT', this.allWeight)
      this.$set(this.goodform, 'dispatchNumber', allNumber)
      this.$set(this.goodform, 'dispatchVolumn', allvolumn)
      this.orderWightFuzhi()
    },
    orderWightFuzhi () {
      if (this.goodform.measuringUnit == '吨') {
        this.$set(this.goodform, 'allWeight', this.goodform.dispatchWeightT)
      } else if (this.goodform.measuringUnit == '件') {
        this.$set(this.goodform, 'allWeight', this.goodform.dispatchNumber)
      } else if (this.goodform.measuringUnit == '方') {
        this.$set(this.goodform, 'allWeight', this.goodform.dispatchVolumn)
      }
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.deleteAttachmentsIds.push(file.id)
      }
    },
    savePDFn (flag) {
      if (this.goodform.truckload > 40 || this.goodform.unloadings > 40 ||
      this.goodform.truckload != this.goodform.unloadings) {
        this.$confirm('已超过标载40吨或装车量、卸车量、结算量不一致！是否继续？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.saveFn(flag)
        }).catch(() => {

        })
      } else {
        this.saveFn(flag)
      }
    },
    async saveFn (flag) {
      if (!this.goodform.allWeight) {
        this.$alert('运单量不能为0', '系统提示')
        return
      }
      if (!this.goodform.deliverAddressId) {
        this.$alert('请选择发货地址', '系统提示')
        return
      }
      if (!this.goodform.receivingAddressId) {
        this.$alert('请选择收货地址', '系统提示')
        return
      }
      if (this.goodform.transportMode == 1) {
        if (!this.goodform.driverName) {
          this.$alert('请选择司机', '系统提示')
          return false
        }
        if (!this.goodform.plateNumber) {
          this.$alert('请选择车辆', '系统提示')
          return false
        }
      }

      let kehu = await findCustomerInfoList({
        pageNo: 1,
        businessType: 1,
        pageSize: 50,
        customerName: this.goodform.payee
      })
      let zcFlag = 0
      if (kehu.list.length == 0) {
        zcFlag = 0
      } else {
        zcFlag = kehu.list[0].loadingVoucher
      }
      if (this.ZCimgList.length == 0 && zcFlag == 1) {
        this.$alert('请选择装车凭证', '系统提示')
        return false
      }
      if (this.XCimgList.length == 0 && this.goodform.wayState >= 3) {
        this.$alert('请选择卸车凭证', '系统提示')
        return false
      }

      // let PTWHFlag = await pushWayToWHPTFlag()// 平台是否推送网货
      // if (PTWHFlag && this.goodform.onlineFreightFlag == 1) {
      //   this.$alert('不能选择推送网货的承运商', '系统提示')
      //   return false
      // }
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.wayBusinessType)
      if (yewuleixingJson.length > 0) {
        this.goodform.wayBusinessTypeName = yewuleixingJson[0].showName
      } else {
        this.$set(this.goodform, 'wayBusinessType', null)
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.goodform.pickupTime) {
            this.goodform.pickupTimeStart = this.goodform.pickupTime[0]
            this.goodform.pickupTimeEnd = this.goodform.pickupTime[1]
          }
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json.length > 0) {
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.payeeCode = json[0].tenantCode
          }
          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
            this.goodform.payerCode = ''
          }
          // 赋值调度量
          this.$set(this.goodform, 'dispatchWeight', this.goodform.allWeight)
          // 运费总额赋值
          this.$set(this.goodform, 'freightAmount', this.goodform.allFreightAmount)

          if (this.goodform.reverseCountFlag == 1) { // 反算的时候清一下支出附加费
            this.$set(this.goodform, 'disburseSurcharge', '')
          }
          console.log(this.goodform, 'this.goodform66666666666')
          if (flag == 2) {
            this.$set(this.goodform, 'signRiskControlState', 3) // 通过
          } else if (flag == 3) {
            this.$set(this.goodform, 'signRiskControlState', 4) // 异常
            if (!this.goodform.signRiskControlRemark) {
              this.$alert('请输入异常原因', '系统提示')
              loading.close()
              return false
            }
          }
          // 组装数据
          let data = {}
          data.tWay = { ...this.goodform }
          data.disburseSurchargeFlag = this.goodform.disburseSurchargeFlag

          data.goodslist = []// 修改只传新加的值
          this.goodform.goodsList.forEach(item => {
            if (!item.wayGoodsRelId) {
              data.goodslist.push(item)
            }
          })
          data.deleteWayGoodsRelIds = this.goodform.deleteWayGoodsRelIds
          data.deleteAttachmentsIds = this.deleteAttachmentsIds

          data.payeeCode = this.goodform.settlementCustomersCode
          data.payerCode = this.goodform.generalCode

          data.tWayBusiness = this.tWayBusiness// 把业务实体整个赋值
          // 收入相关
          data.tWayBusiness.payee = this.goodform.payee
          data.tWayBusiness.payeeTaxId = this.goodform.payeeTaxId
          data.tWayBusiness.payeeCode = this.goodform.payeeCode
          data.tWayBusiness.incomePattern = this.goodform.incomePattern
          data.tWayBusiness.revenueValuation = this.goodform.revenueValuation
          data.tWayBusiness.incomePatternName = this.goodform.incomePatternName
          data.tWayBusiness.revenueValuationName = this.goodform.revenueValuationName
          data.tWayBusiness.makeTicketYn = this.goodform.makeTicketYn
          data.tWayBusiness.ticketSystemYn = this.goodform.ticketSystemYn
          data.tWayBusiness.incomeUnitPrice = this.goodform.incomeUnitPrice
          data.tWayBusiness.incomeAmount = this.goodform.incomeAmount
          data.tWayBusiness.generalCarrier = this.goodform.generalCarrier
          data.tWayBusiness.generalTaxId = this.goodform.generalTaxId
          data.tWayBusiness.collectionType = this.goodform.collectionType
          data.tWayBusiness.payer = this.goodform.payer
          data.tWayBusiness.payerTaxId = this.goodform.payerTaxId
          data.tWayBusiness.payerCode = this.goodform.payerCode
          data.tWayBusiness.expenditurePattern = this.goodform.expenditurePattern
          data.tWayBusiness.freightPricingType = this.goodform.freightPricingType
          data.tWayBusiness.expenditurePatternName = this.goodform.expenditurePatternName
          data.tWayBusiness.freightPricingTypeName = this.goodform.freightPricingTypeName
          data.tWayBusiness.freightUnitPrice = this.goodform.freightUnitPrice
          data.tWayBusiness.freightAmount = this.goodform.freightAmount
          data.tWayBusiness.serviceRate = this.goodform.serviceRate
          data.tWayBusiness.serviceCharge = this.goodform.serviceCharge
          data.tWayBusiness.freightTaxRate = this.goodform.freightTaxRate
          data.tWayBusiness.onlineFreightFlag = this.goodform.onlineFreightFlag
          data.tWayBusiness.revenueSurcharge = this.goodform.revenueSurcharge
          data.tWayBusiness.disburseSurcharge = this.goodform.disburseSurcharge
          data.tWayBusiness.grossRevenue = this.goodform.grossRevenue
          data.tWayBusiness.freightRemark = this.goodform.freightRemark
          data.tWayBusiness.incomeRemark = this.goodform.incomeRemark

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(data))
          this.ZCimgList.forEach(item => {
            if (!item.id) {
              imgfile.append('loadFiles', item.raw)
            }
          })
          this.XCimgList.forEach(item => {
            if (!item.id) {
              imgfile.append('unLoadFiles', item.raw)
            }
          })
          signRisk(imgfile).then(res => {
            if (this.goodform.wmsOutstockNo && data.deleteWayGoodsRelIds.length > 0) {
              this.$message({
                showClose: true,
                message: '仓库出库单' + this.goodform.wmsOutstockNo + '货物已删除成功！',
                type: 'success',
                onClose () {
                  loading.close()
                }
              })
            }

            loading.close()
            this.$emit('update:fengkongFlag', false)
            this.$parent.searchFn()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 运单状态改变
    wayStateChange (e) {
      if (e == 1) {
        this.$set(this.goodform, 'truckload', '')
        this.$set(this.goodform, 'actualLoadingTime', '')
        this.ZCimgList = []
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
      } else if (e == 2) {
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
      } else if (e == 3) {
        this.$set(this.goodform, 'receiptRequest', '')
      } else if (e == 4) {
        this.$set(this.goodform, 'receiptRequest', '正常签收')
      }
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payCustomerId = json[0].id
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.payeeCode = json[0].tenantCode
      this.goodform.salesContract = ''
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }
    },
    xuanzeHT () {
      this.GLHTflag = true
    },
    delGoodFn () {
    },
    closeDialog () {
      this.$emit('update:fengkongFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.remark .el-input .el-input__inner{
  width: 800px;
  height: 80px;
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
.width1  /deep/.el-input__inner{
  width:100px;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}
.imgBox{
  margin: 0px 15px  10px;
}
/deep/.el-range-editor{
  width: 430px;
}
.boxSR /deep/.el-input__inner{
  width: 100px;
}
/deep/.el-form-item--mini .el-form-item__label{
  font-size: 12px;
}
/deep/.el-form-item--mini .el-form-item__content{
  font-size: 12px;
}
/deep/.el-table th>.cell{
  font-size: 12px;
}
.bottomBtn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  padding: 16px 0;
  z-index: 1000;
}
.map-toolbar {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/deep/.map-fullscreen-dialog {
  .el-dialog {
    margin: 0 !important;
    top: 0 !important;
    .el-dialog__header {
      padding: 10px 20px;
      background: #f5f7fa;
      border-bottom: 1px solid #e4e7ed;
    }
    .el-dialog__body {
      padding: 0;
      height: calc(100vh - 53px);
    }
  }
}
</style>
